import { DriverTime } from "model/Match/DriverTime";
import { RoundSpan } from "./Span/RoundSpan";

export type TimeAttackTimes = {
  [driverId: string]: number;
};

export type TimeAttackRound = {
  name: string | undefined;
  span: RoundSpan;
  times: TimeAttackTimes;
};

export const getTimeAttackRoundDriverTimes = (
  round: TimeAttackRound
): DriverTime[] => {
  return Object.keys(round.times).map((driverId) => ({
    driverId,
    finishTimeMs: round.times[driverId],
  }));
};

export const getTimeAttackRoundBestTime = (round: TimeAttackRound) => {
  const finishTimes = Object.values(round.times).filter((t) => t > 0);
  if (finishTimes.length === 0) {
    return undefined;
  }

  return Math.min(...finishTimes);
};
